export default __webpack_public_path__ + "media/images/icon_lists-e1c87661f6c1e7aab27740c16777ecc9.png";